"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.array.find");require("core-js/modules/es6.regexp.split"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default =
{
  data: function data() {
    return {
      tableData: [], //列表数据
      droplist: [],
      deviceTypeCodeList: [],
      searchData: {
        sn: '',
        deviceTypeCode: '',
        page: 1, //当前页码
        rows: 10 //页码条数
      },

      pageData: {
        page: 1,
        rows: 10,
        total: 0,
        pages: 1 },

      addpageData: {
        page: 1,
        rows: 10,
        total: 0,
        pages: 1 },

      addData: {
        id: '',
        deviceTypeName: '',
        doFirmwareVersionId: '',
        doFirmwareVersion: '',
        partCode: '',
        //					serverHost: '',
        //					serverPort: '',
        sn: '',
        sns: '' },

      defaultData: {
        id: '',
        deviceTypeName: '',
        doFirmwareVersionId: '',
        doFirmwareVersion: '',
        partCode: '',
        //					serverHost: '',
        //					serverPort: '',
        sn: '',
        sns: '' },

      title: '升级',
      newadd: false,
      rules: {
        //					merchantId: [{
        //						title: "升级",
        //						required: true,
        //						message: '请选择商户',
        //						trigger: 'change'
        //					}],
        //					address: [{
        //						required: true,
        //						message: '请输入投放地址',
        //						trigger: 'blur'
        //					}],
      } };

  },
  mounted: function mounted() {
    var self = this;
    self.init();
    self.getdrop2();
    //			self.getdrop()
  },
  methods: {
    init: function init() {
      var self = this;
      self.getData('/api/faDeviceInfo', self.searchData, function (res) {
        self.tableData = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
        if (self.tableData != null) {
          self.getData("/api/menu/button/pers", {}, function (res2) {
            for (var i = 0; i <= res2.length - 1; i++) {
              var first = res2[i];
              for (var j = 0; j < first.childs.length; j++) {
                var second = first.childs[j];
                for (var t = 0; t < second.childs.length; t++) {
                  var third = second.childs[t];
                  if (third.permission == 'firmware:upgrade:delbatch' && third.isPer) {
                    $(".delbatch").addClass("hide");
                  } else if (third.permission == 'firmware:upgrade:upgrade' && third.isPer) {
                    $(".upgrade").addClass("hide");
                  }
                }
              }
            }
          });
        }
      });
    },
    resetFun: function resetFun() {//重置
      this.searchData.page = 1;
      this.searchData.rows = 10;
      this.searchData.sn = '';
      this.searchData.deviceTypeCode = '';
      this.init();
    },

    searchFun: function searchFun() {//搜索事件
      this.searchData.page = 1;
      this.init();
    },
    handleSizeChange: function handleSizeChange(val) {//分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {//分页页码
      this.searchData.page = val;
      this.init();
    },
    //			addFun: function() { // 新增
    //				this.title = '新增'
    //				this.addData = JSON.parse(JSON.stringify(this.defaultData))
    //				this.newadd = true
    //			},
    closeRefund: function closeRefund(done) {//重置新增列表
      this.$refs['addForm'].resetFields();
      done();
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faFirmwareDo/upgrade', self.addData, function (res) {
            self.$message({
              message: '固件升级已提交成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    updata: function updata(item) {
      this.title = '升级';
      var self = this;
      this.addData = {
        id: item.id,
        sn: item.sn,
        deviceTypeName: item.deviceTypeName,
        doFirmwareVersion: item.doFirmwareVersion,
        partCode: item.partCode
        //					serverHost: item.serverHost,
        //					serverPort: item.serverPort,
      };
      self.newadd = true;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var self = this;
      self.addData.sns = '';
      //				val.map(function(item) {
      //					self.addData.sns += item.sn + ','
      //				})
      val.map(function (item) {
        self.addData.sns += item.sn + ',';
      });
    },
    plupdata: function plupdata(item) {
      var self = this;

      if (self.addData.sns == '') {
        self.$message({
          message: '请选择要升级的记录!',
          type: 'warning' });

        return;
      }
      self.title = '批量升级';
      this.newadd = true;
    },
    onPLUpdate: function onPLUpdate() {
      var self = this;
      //				var snstArr = []
      //				var snsStrArr = self.addData.sns.split(",")
      //				snstArr=snsStrArr.map(function(data){
      //			        return +data;
      //			    });

      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faFirmwareDo/batchUpgrade', {
            doFirmwareVersion: self.addData.doFirmwareVersion,
            partCode: self.addData.partCode,
            sns: self.addData.sns.split(",")
            //							sns: snstArr
          }, function (res) {
            self.$message({
              message: '固件升级已批量提交成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    changeappTypeFun: function changeappTypeFun(val) {
      var self = this;
      if (val === '0') {
        self.addData.partCode = '0';
        var firmwareType = self.addData.partCode;
        self.getData('/api/faFirmwareInfo/?firmwareType=' + firmwareType + '&sn=' + self.addData.sn + '', {}, function (res) {
          self.droplist = res.list;
          return;
        });
      }if (val === '1') {
        self.addData.partCode = '1';
        var _firmwareType = self.addData.partCode;
        self.getData('/api/faFirmwareInfo/?firmwareType=' + _firmwareType + '&sn=' + self.addData.sn + '', {}, function (res) {
          self.droplist = res.list;
          return;
        });
      }
    },
    //			getdrop: function() {
    //				let self = this
    //				self.getData('/api/faFirmwareInfo/?partCode='+self.addData.partCode+'&sn='+self.addData.sn+'', {}, function(res) {
    //					self.droplist = res.list
    //				})
    //			},
    changeproductFun: function changeproductFun(data) {
      var obj = {};
      obj = this.droplist.find(function (item) {
        return item.id === data;
      });
      this.addData.doFirmwareVersion = obj.version;
      this.addData.doFirmwareVersionId = obj.id;
    },

    getdrop2: function getdrop2() {
      var self = this;
      self.getData('/api/faDeviceType/getDownList', {}, function (res) {
        self.deviceTypeCodeList = res;
      });
    } } };exports.default = _default;